export default __webpack_public_path__ + "img/sagoo/sagoo1_1500.jpg";